import React, { useLayoutEffect, useState, useRef } from "react";
import {
  Card_URL,
  UPDATE_CONTACT_EXCHNAGE_STATUS,
  AI_CARD_SESSIONS,
  SOCIAL_LOGIN_SAVE,
  LINKEDIN_AUTH,
  OCR_UPLOAD,
  OCR_ANALYZE,
  OCR_UPLOAD_ANALYZE,
  OCR_SAVE,
} from "../utils/constants/apiUrl";
// import classes from "../assets/styles/Contact.module.css";
import AddIcon from "../assets/images/global_icons/basil_add-solid.svg";
import { useEffect } from "react";
import { get, deleteRecord, put, post } from "../server";
import { loggedInUser, teamIDCheck, accountType } from "../utils/store";
import { useAtom } from "jotai";
import Loader from "../components/Loader";
import ConfirmationModal from "../components/Modals/ConfirmationModal";
import showToast from "../helpers/showToast";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import FunctionsLimitModal from "../components/Modals/FunctionsLimitModal";
import { subscribedPackage } from "../utils/store";
import AddNewCard from "../components/PageComponents/Home/AddNewCard";
import PersonalCard from "../components/PageComponents/Home/PersonalCard";
import BusinessCard from "../components/PageComponents/Home/BusinessCard";
import { FiChevronLeft, FiChevronRight, FiEdit } from "react-icons/fi";
import { BsStars } from "react-icons/bs";
import EmptyListingBanner from "../components/EmptyListingBanner";
import functionTypes from "../utils/constants/functionTypes";
import useFunctionsCount from "../hooks/useFunctionsCount";
import { trackEvent } from "../utils/mixpanel";
import { MdAddBox } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { Button, Col, Row, Modal, Form } from "react-bootstrap";
import { FaFacebookF, FaGoogle, FaApple, FaLinkedinIn } from "react-icons/fa";
import aiLogo from "../assets/images/ai-logo.png";
import { useGoogleLogin } from "@react-oauth/google";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";

const Card = () => {
  const navigate = useNavigate();
  const { teamId, userId } = useParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const team_id = searchParams.get("team_id");
  const user_id = searchParams.get("user_id");
  const dynamicQRCodeId = searchParams.get("dynamic_qr_code");

  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const triggerFbLogin = useRef();
  const [userTeamId, setUserTeamId] = useAtom(teamIDCheck);
  const [personalAccount] = useAtom(accountType);
  const [gridView, setGridView] = useState(false);
  const [loading, setLoading] = useState(false);
  const [cards, setCards] = useState([]);
  const [deleteId, setDeleteId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [personalCards, setPersonalCards] = useState([]);
  const [businessCards, setBusinessCards] = useState([]);
  const [removeInfoSection, setRemoveInfoSection] = useState(false);
  const socialActionTypeRef = useRef("ai");
  const fileInputRef = useRef(null);
  const {
    compareLimits,
    updateCount,
    limitExceededForStarter,
    compareLimitsForDynamicQR,
  } = useFunctionsCount();
  const [dynamicQRCode, setDynamicQRCode] = useState(false);
  const [activeTab, setActiveTab] = useState("personal");
  const [contactExchangeButton, setContactExchangeButton] = useState(false);
  const [showNewCardModal, setShowNewCardModal] = useState(false);
  const [showManualCardModal, setShowManualCardModal] = useState(false);
  const [showAddNewCard, setShowAddNewCard] = useState(false);
  const [purchasedPackage, setPurchasedPackage] = useAtom(subscribedPackage);
  const [showLimitModal, setShowLimitModal] = useState(false);

  // OCR state
  const [showResolutionModal, setShowResolutionModal] = useState(false);
  const [ocrResultData, setOcrResultData] = useState(null);
  const [ocrImages, setOcrImages] = useState({ logo: null, profile_image: null });
  const [selectedDuplicateAction, setSelectedDuplicateAction] = useState("new");
  const [selectedDuplicateId, setSelectedDuplicateId] = useState(null);
  const [useAiSuggestion, setUseAiSuggestion] = useState(true);
  const [editOriginalFields, setEditOriginalFields] = useState({
    first_name: "", last_name: "", email: "", company: "", company_position: "", website_url: "", phones: "", address: ""
  });
  const [editAiFields, setEditAiFields] = useState({
    first_name: "", last_name: "", email: "", company: "", company_position: "", website_url: "", phones: "", address: ""
  });

  useEffect(() => {
    if (ocrResultData) {
      if (ocrResultData.ocr_data) {
        setEditOriginalFields({
          first_name: ocrResultData.ocr_data.first_name || "",
          last_name: ocrResultData.ocr_data.last_name || "",
          email: ocrResultData.ocr_data.email || "",
          company: ocrResultData.ocr_data.company || "",
          company_position: ocrResultData.ocr_data.company_position || "",
          website_url: ocrResultData.ocr_data.website_url || ocrResultData.ocr_data.website || "",
          phones: Array.isArray(ocrResultData.ocr_data.phones) ? ocrResultData.ocr_data.phones.join(", ") : (ocrResultData.ocr_data.phones || ""),
          address: ocrResultData.ocr_data.address || "",
        });
      }

      if (ocrResultData.ai_suggestions?.corrected_data) {
        setEditAiFields({
          first_name: ocrResultData.ai_suggestions.corrected_data.first_name || "",
          last_name: ocrResultData.ai_suggestions.corrected_data.last_name || "",
          email: ocrResultData.ai_suggestions.corrected_data.email || "",
          company: ocrResultData.ai_suggestions.corrected_data.company || "",
          company_position: ocrResultData.ai_suggestions.corrected_data.company_position || "",
          website_url: ocrResultData.ai_suggestions.corrected_data.website_url || ocrResultData.ai_suggestions.corrected_data.website || "",
          phones: Array.isArray(ocrResultData.ai_suggestions.corrected_data.phones) ? ocrResultData.ai_suggestions.corrected_data.phones.join(", ") : (ocrResultData.ai_suggestions.corrected_data.phones || ""),
          address: ocrResultData.ai_suggestions.corrected_data.address || "",
        });
      }
    }
  }, [ocrResultData]);

  const handleEditOriginalChange = (e) => {
    const { name, value } = e.target;
    setEditOriginalFields(prev => ({ ...prev, [name]: value }));
  };

  const handleEditAiChange = (e) => {
    const { name, value } = e.target;
    setEditAiFields(prev => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.type === "LINKEDIN_LOGIN_SUCCESS") {
        handleSocialAICreate("linkedin");
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [loggedUser]);

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const handleNewCardPopupOpen = () => setShowNewCardModal(true);
  const handleNewCardPopupClose = () => setShowNewCardModal(false);

  const handleRemoveInfoSection = () => {
    setRemoveInfoSection(true);
  };

  const fbLoginPromiseRef = useRef(null);

  const handleDelete = (id) => {
    setDeleteId(id);
    handleShowModal(true);
  };
  // useEffect(() => {
  //   // Extract pathname segments
  //   const pathSegments = window.location.pathname.split("/");
  //   if (pathSegments.length > 1 && pathSegments[1] === "dynamicQRCode") {
  //     setDynamicQRCode(true); // 'dynamicQRCode'
  //   }
  // }, []);
  // useEffect(() => {}, []);

  const handleConfirmDelete = async () => {
    handleCloseModal(true);
    setLoading(true);
    let queryParams = "";

    if (dynamicQRCodeId) {
      queryParams += `?dynamic_qr_code_id=${dynamicQRCodeId}`;
    }

    if (teamId || team_id || userTeamId) {
      queryParams += `${queryParams ? "&" : "?"}team_id=${teamId || team_id || userTeamId
        }`;
    }

    // if (teamId || team_id || userTeamId) {
    //   queryParams = `?team_id=${teamId || team_id || userTeamId}`;
    // }

    let { status, message } = await deleteRecord(
      `${Card_URL}/${deleteId}${queryParams}`,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );

    showToast(status, message);

    if (status) {
      updateCount(functionTypes.CARD, functionTypes.DELETE, dynamicQRCodeId);
      await loadCard();
      setLoading(false);
    }
  };

  const loadCard = async () => {
    setLoading(true);
    // const searchParams = new URLSearchParams(window.location.search);
    // if (searchParams.has("dynamic_qr_code")) {
    //   setDynamicQRCode(true);
    //   const qrCodeId = searchParams.get("dynamic_qr_code");
    // }
    let queryParams = "";
    if (dynamicQRCodeId) {
      queryParams += `?dynamic_qr_code_id=${dynamicQRCodeId}`;
    }

    const connectedTeams = loggedUser?.connected_teams;
    const connectedTeamId = Array.isArray(connectedTeams)
      ? connectedTeams[0]?.id
      : connectedTeams?.id;
    const memberTeamId =
      connectedTeamId ||
      loggedUser?.team_members?.find((member) => member?.team_id)?.team_id ||
      loggedUser?.secret_code?.find((item) => item?.team_id)?.team_id ||
      loggedUser?.teams?.id ||
      null;
    const activeTeamId = teamId || team_id || userTeamId || memberTeamId;
    const currentMembership =
      loggedUser?.team_members?.find(
        (member) =>
          String(member.team_id) === String(activeTeamId) &&
          loggedUser?.email &&
          member.user_data?.email === loggedUser.email
      ) ||
      loggedUser?.team_members?.find(
        (member) =>
          String(member.team_id) === String(activeTeamId) &&
          String(member.user_id) === String(loggedUser?.id)
      );
    const connectedTeam = Array.isArray(connectedTeams)
      ? connectedTeams.find(
          (team) => String(team.id ?? team.team_id) === String(activeTeamId)
        ) || connectedTeams[0]
      : connectedTeams;
    const currentTeamUserId =
      currentMembership?.user_id ||
      connectedTeam?.pivot?.user_id ||
      connectedTeam?.team_member?.user_id ||
      connectedTeam?.membership?.user_id ||
      loggedUser?.user_data?.id ||
      loggedUser?.id ||
      null;
    const cardListTeamId =
      teamId ||
      team_id ||
      userTeamId ||
      (!personalAccount ? memberTeamId : null);

    if (cardListTeamId) {
      queryParams += `${queryParams ? "&" : "?"}team_id=${cardListTeamId}`;
    }

    const cardListUserId =
      userId || (!personalAccount ? currentTeamUserId : user_id) || user_id;
    if (cardListUserId) {
      queryParams += `${queryParams ? "&" : "?"}user_id=${cardListUserId}`;
    }

    let { status, message, data } = await get(
      `${Card_URL}${queryParams}`,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );

    if (status) {
      if (data.length > 0) {
        handlePersonalBusinessCard(data);
        setCards(data);
      } else {
        setPersonalCards([]);
        setBusinessCards([]);
        setCards([]);
      }
    } else {
      showToast(status, message);
    }

    setLoading(false);
  };

  const handlePersonalBusinessCard = (data) => {
    let personalCardsData = [];
    let businessCardsData = [];

    data.forEach((card) => {
      if (card.card_type === "personal") {
        personalCardsData.push(card);
      } else {
        businessCardsData.push(card);
      }

      setPersonalCards(personalCardsData);
      setBusinessCards(businessCardsData);
    });
  };

  const handlePersonalScrollLeft = () => {
    document.getElementById("personalCardWrapper").scrollLeft -= 220;
  };

  const handlePersonalScrollRight = () => {
    document.getElementById("personalCardWrapper").scrollLeft += 220;
  };

  const handleBusinessScrollLeft = () => {
    document.getElementById("businessCardWrapper").scrollLeft -= 220;
  };

  const handleBusinessScrollRight = () => {
    document.getElementById("businessCardWrapper").scrollLeft += 220;
  };

  useEffect(() => {
    loadCard();
  }, [userTeamId, personalAccount]);
  const handleGoBack = () => {
    navigate(-1);
  };

  const handleTracking = (data) => {
    trackEvent(data, {
      message: data,
    });
  };

  const handleNewCard = () => {
    navigate(
      team_id && user_id && dynamicQRCodeId !== null
        ? `?team_id=${team_id}&user_id=${user_id}&dynamic_qr_code=${dynamicQRCodeId}`
        : teamId && userId
          ? `/team/${teamId}/teamMembers/member/${userId}/function/cardfunctions`
          : `/function/cardfunctions${team_id && user_id
            ? `?team_id=${team_id}&user_id=${user_id}`
            : dynamicQRCodeId !== null
              ? `?dynamic_qr_code=${dynamicQRCodeId}`
              : ""
          }`
    );
  };

  const transformCardFormBuilderData = (fields) => {
    return fields.map((field) => {
      const element = {
        type: field.type === "inputbox" ? "input" : field.type,
        label: field.label,
        options: [],
        isPreDefined: field.is_predefined === 1,
        fieldType: field.field_type,
        isMandatory: field.is_required === 1,
      };
      return element;
    });
  };

  const handleContactExchange = async (e) => {
    e.preventDefault();
    const payload = {
      enabled: contactExchangeButton,
      team_id: teamId || team_id,
    };
    let { status, message, data } = await put(
      UPDATE_CONTACT_EXCHNAGE_STATUS,
      payload,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    // if (status) {
    //   navigate();
    // }
  };

  const handleOcrUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 10 * 1024 * 1024) {
      showToast(false, "Image size exceeds 10MB limit.");
      if (fileInputRef.current) fileInputRef.current.value = "";
      return;
    }

    const formData = new FormData();
    // Reverted back to "image" as the key, as it's the more likely parameter name for a file upload validation.
    // Also appending "file" as a fallback if the backend expects "file".
    formData.append("image", file);
    formData.append("file", file);
    if (teamId || team_id || userTeamId) {
      formData.append("team_id", teamId || team_id || userTeamId);
    }

    setLoading(true);
    try {
      const response = await fetch(OCR_UPLOAD, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${loggedUser.token}`,
        },
        body: formData,
      });

      const resData = await response.json();

      if (response.ok && resData.success !== false) {
        const extractedData = resData.data || resData;

        // Store logo and profile_photo from Node OCR response
        setOcrImages({
          logo: extractedData.logo?.logoImage || null,
          profile_image: extractedData.profile_photo?.profileImage || null,
        });

        // Step 2 -> Analyze extracted data (duplicate detection + AI suggestions)
        const analyzePayload = {
          first_name: extractedData.first_name || "",
          last_name: extractedData.last_name || "",
          email: extractedData.email || "",
          company: extractedData.company || "",
          company_position: extractedData.company_position || "",
          website: extractedData.website || "",
          address: extractedData.address || "",
          phones: extractedData.phones || [],
          team_id: teamId || team_id || userTeamId || null,
        };

        const analyzeResponse = await fetch(OCR_ANALYZE, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${loggedUser.token}`,
          },
          body: JSON.stringify(analyzePayload),
        });

        const analyzeDataRaw = await analyzeResponse.json();

        if (analyzeResponse.ok && analyzeDataRaw.success !== false) {
          const analyzeData = analyzeDataRaw.data || analyzeDataRaw;
          setOcrResultData(analyzeData);

          // Setup initial default for duplicate selection
          if (analyzeData.has_duplicates && analyzeData.duplicates?.length > 0) {
            setSelectedDuplicateAction("merge");
            const firstDup = analyzeData.duplicates[0];
            setSelectedDuplicateId(firstDup.existing_contact_id || firstDup.contact_id || firstDup.id || null);
          } else {
            setSelectedDuplicateAction("new");
          }

          setShowResolutionModal(true);
        } else {
          console.error("OCR Analyze Error:", analyzeDataRaw);
          showToast(false, "Data extraction succeeded, but analysis failed. Review raw data.");
          setOcrResultData({ ocr_data: extractedData, has_duplicates: false });
          setSelectedDuplicateAction("new");
          setShowResolutionModal(true);
        }
      } else {
        const errorMsg =
          resData.message || "Failed to process image (Validation failed).";
        const detailedErrors = resData.errors
          ? Object.values(resData.errors).flat().join(", ")
          : "";
        console.error("OCR Upload Error:", resData);
        showToast(
          false,
          detailedErrors ? `${errorMsg}: ${detailedErrors}` : errorMsg
        );
      }
    } catch (error) {
      console.error("OCR Request failed:", error);
      showToast(false, "Network error while uploading image.");
    } finally {
      if (fileInputRef.current) fileInputRef.current.value = "";
      setLoading(false);
    }
  };

  const handleOcrSave = async () => {
    if (!ocrResultData) return;
    setLoading(true);

    const activeFields = useAiSuggestion ? editAiFields : editOriginalFields;

    if (selectedDuplicateAction === "merge" || selectedDuplicateAction === "keep_both") {
      if (!selectedDuplicateId) {
        showToast(false, "Please select an existing contact to target.");
        setLoading(false);
        return;
      }
    }

    let savePayload = {};

    const cityVal = activeFields.city || "";
    const stateVal = activeFields.state || "";
    const countryVal = activeFields.country || "";

    if (selectedDuplicateAction === "new" || selectedDuplicateAction === "keep_both") {
      savePayload = {
        action: selectedDuplicateAction,
        first_name: activeFields.first_name || "Unknown",
        last_name: activeFields.last_name || "",
        email: activeFields.email || "",
        company: activeFields.company || "",
        company_position: activeFields.company_position || "",
        website_url: activeFields.website_url || "",
        address: activeFields.address || "",
        city: cityVal,
        state: stateVal,
        country: countryVal,
        card_type: "business",
        logo: ocrImages.logo || "",
        profile_image: ocrImages.profile_image || "",
        contact_card_phone: activeFields.phones ? activeFields.phones.split(",").map(p => ({ phone_number: p.trim(), phone_type: "mobile" })) : [],
        contact_card_social_media: []
      };

      if (selectedDuplicateAction === "keep_both") {
        savePayload.existing_contact_id = selectedDuplicateId;
      }
    } else if (selectedDuplicateAction === "merge") {
      savePayload = {
        action: "merge",
        first_name: activeFields.first_name || "Unknown",
        existing_contact_id: selectedDuplicateId,
        merge_fields: {
          first_name: activeFields.first_name || "Unknown",
          last_name: activeFields.last_name || "",
          email: activeFields.email || "",
          company: activeFields.company || "",
          company_position: activeFields.company_position || "",
          website_url: activeFields.website_url || "",
          address: activeFields.address || "",
          city: cityVal,
          state: stateVal,
          country: countryVal,
          logo: ocrImages.logo || "",
          profile_image: ocrImages.profile_image || "",
        },
        phone_action: {
          action: "add",
          phones: activeFields.phones ? activeFields.phones.split(",").map(p => ({ phone_number: p.trim(), phone_type: "mobile" })) : []
        },
        social_action: {
          action: "keep",
          entries: []
        }
      };
    }


    try {
      const response = await fetch(OCR_SAVE, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${loggedUser.token}`,
        },
        body: JSON.stringify(savePayload),
      });

      const resData = await response.json();
      if (response.ok && resData.success !== false) {
        showToast(true, "Contact saved successfully!");
        setShowResolutionModal(false);

        // Use the finalData directly to always flatten properties (like company, email)
        // because savePayload nests them under merge_fields during an "merge" action.
        const prefillVal = {
          ...(resData.data || {}),
          ...activeFields,
          contact_card_phone: activeFields.phones ? activeFields.phones.split(",").map(p => ({ phone_number: p.trim(), phone_type: "mobile" })) : [],
          phones: activeFields.phones ? activeFields.phones.split(",").map(p => p.trim()) : [],
        };

        if (selectedDuplicateAction === "merge" || selectedDuplicateAction === "keep_both") {
          navigate("/function/cards");
        } else {
          handleNavigationWithPrefill(prefillVal);
        }
      } else {
        const errorMsg = resData.message || "Failed to save contact.";
        showToast(false, errorMsg);
      }
    } catch (error) {
      console.error("OCR Save Error:", error);
      showToast(false, "Network error saving contact.");
    } finally {
      setLoading(false);
    }
  };

  const checkPlanLimit = (onSuccess) => {
    if (dynamicQRCodeId !== null) {
      let res = compareLimitsForDynamicQR(functionTypes.CARD, dynamicQRCodeId);
      if (res) {
        return showToast(
          false,
          "The requested feature is not compatible with your current plan. Upgrade your plan to continue using these features"
        );
      } else {
        onSuccess();
      }
    } else if (purchasedPackage.id === 1) {
      limitExceededForStarter()
        .then((isLimitExceeded) => {
          if (isLimitExceeded) {
            setShowLimitModal(true);
          } else {
            onSuccess();
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    } else {
      const res = compareLimits(functionTypes.CARD);
      if (res) {
        return showToast(
          false,
          "The requested feature is not compatible with your current plan. Upgrade your plan to continue using these features"
        );
      } else {
        onSuccess();
      }
    }
  };

  const handleProceed = () => {
    checkPlanLimit(() => {
      navigate("/function/cards/ai-card-builder");
    });
  };

  const loginWithGoogle = useGoogleLogin({
    onSuccess: (codeResponse) => {
      fetch(
        `https://www.googleapis.com/oauth2/v3/userinfo?access_token=${codeResponse.access_token}`
      )
        .then((res) => res.json())
        .then(async (users) => {
          setLoading(true);
          const { status, message } = await post(
            SOCIAL_LOGIN_SAVE,
            {
              provider_type: "google",
              token: users.sub,
              email: users.email,
              first_name: users.given_name,
              last_name: users.family_name,
            },
            Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
          );
          if (status) {
            if (socialActionTypeRef.current === "manual") {
              handleNavigationWithPrefill({
                first_name: users.given_name,
                last_name: users.family_name,
                email: users.email,
              });
            } else {
              handleSocialAICreate("google");
            }
          } else {
            showToast(status, message);
          }
          setLoading(false);
        })
        .catch((error) => {
          showToast(false, error);
          setLoading(false);
        });
    },
    onError: (err) => {
      setLoading(false);
      showToast(false, err);
    },
  });

  const loginWithFacebook = () => {
    return new Promise((resolve, reject) => {
      fbLoginPromiseRef.current = { resolve, reject };

      if (triggerFbLogin.current) {
        triggerFbLogin.current(); // opens FB popup
      } else {
        fbLoginPromiseRef.current = null;
        reject(new Error("Facebook login is not initialized"));
      }
    });
  };

  const handleLinkedinAuth = async () => {
    setLoading(true);
    let { status, message, data } = await get(
      `${LINKEDIN_AUTH}?platform=web&card_type=personal&redirect=ai-card/auth/linkedin/success`,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    if (status) {
      window.open(data?.url, "_blank", "width=600,height=600");
    } else {
      showToast(status, message);
    }
    setLoading(false);
  };

  const responseFacebook = async (response) => {
    try {
      if (response?.error?.message) {
        showToast(false, response.error.message);
        fbLoginPromiseRef.current?.reject(new Error(response.error.message));
        fbLoginPromiseRef.current = null;
        return;
      }

      if (!response?.id) {
        showToast(false, "Authentication failed");
        fbLoginPromiseRef.current?.reject(new Error("Authentication failed"));
        fbLoginPromiseRef.current = null;
        return;
      }

      setLoading(true);

      let payload = { ...response };

      if (response?.name) {
        let dataName = handleFaceBookName(response?.name);
        if (dataName.length > 0) {
          payload.first_name = dataName[0];
          payload.last_name = dataName[1];
        }
      }

      const { status, message } = await post(
        SOCIAL_LOGIN_SAVE,
        {
          provider_type: "facebook",
          token: response.id,
          email: response.email,
          first_name: payload.first_name,
          last_name: payload.last_name,
        },
        Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
      );

      if (!status) {
        showToast(false, message);
        fbLoginPromiseRef.current?.reject(new Error(message));
        fbLoginPromiseRef.current = null;
        return;
      }

      // ✅ FB connected
      fbLoginPromiseRef.current?.resolve(true);
      fbLoginPromiseRef.current = null;

      if (socialActionTypeRef.current === "manual") {
        handleNavigationWithPrefill({
          first_name: payload.first_name,
          last_name: payload.last_name,
          email: response.email,
        });
      } else {
        // ✅ Continue with AI session create
        await handleSocialAICreate("facebook");
      }
    } catch (err) {
      showToast(false, err?.message || "Facebook login failed");
      fbLoginPromiseRef.current?.reject(err);
      fbLoginPromiseRef.current = null;
    } finally {
      setLoading(false);
    }
  };

  const handleFaceBookName = (str) => {
    if (str) {
      let lastString = str.trim().split(" ").slice(-1);
      if (lastString.length > 0) {
        let firstName = str.replace(lastString["0"], "");
        let nameArr = [];
        nameArr.push(firstName, lastString["0"]);
        return nameArr;
      }
    }
    return [];
  };

  const handleFacebookAuth = async () => {
    if (triggerFbLogin.current) {
      triggerFbLogin.current();
    }
  };

  const handleAppleAuth = async () => {
    setLoading(true);
    const mockUser = {
      given_name: "Demo",
      family_name: "AAAA",
      sub: "apple_7891011001",
      email: "demo1@company.com",
    };
    const { status, message } = await post(
      SOCIAL_LOGIN_SAVE,
      {
        provider_type: "apple",
        token: mockUser.sub,
        email: mockUser.email,
        first_name: mockUser.given_name,
        last_name: mockUser.family_name,
      },
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );

    if (status) {
      handleSocialAICreate("apple");
    } else {
      showToast(status, message);
    }
    setLoading(false);
  };

  const handleSocialAICreate = async (provider, tokenOverride = null) => {
    const payload = {
      social_provider: provider,
      platform: "web",
    };

    setLoading(true);
    // ✅ Use the provided token override if available (fresh from login), otherwise fallback to state
    const authToken =
      tokenOverride ||
      (Object.keys(loggedUser).length !== 0 ? loggedUser.token : null);

    let { status, message, data } = await post(
      AI_CARD_SESSIONS,
      payload,
      authToken
    );

    if (status) {
      navigate("/function/cards/ai-card-builder", {
        state: { session_uuid: data.session_uuid },
      });
    } else {
      // Only trigger fallback if not already retrying with a fresh token
      if (
        !tokenOverride &&
        (message?.toLowerCase().includes("no google account connected") ||
          message?.toLowerCase().includes("no facebook account connected") ||
          message?.toLowerCase().includes("no linkedin account connected") ||
          message?.toLowerCase().includes("no apple account connected") ||
          message?.toLowerCase().includes("not connected"))
      ) {
        if (provider === "google") {
          loginWithGoogle();
        } else if (provider === "linkedin") {
          handleLinkedinAuth();
        } else if (provider === "facebook") {
          handleFacebookAuth();
        } else if (provider === "apple") {
          handleAppleAuth();
        } else {
          showToast(status, message);
        }
      } else {
        showToast(status, message);
      }
    }
    setLoading(false);
  };


  const handleNavigation = () => {
    if (dynamicQRCodeId !== null) {
      let res = compareLimitsForDynamicQR(functionTypes.CARD, dynamicQRCodeId);
      if (res) {
        return showToast(
          false,
          "The requested feature is not compatible with your current plan. Upgrade your plan to continue using these features"
        );
      } else {
        navigate(
          teamId && userId
            ? `/team/${teamId}/teamMembers/member/${userId}/function/cardfunctions`
            : `/function/cardfunctions${team_id && user_id && dynamicQRCodeId !== null
              ? `?team_id=${team_id}&user_id=${user_id}&dynamic_qr_code=${dynamicQRCodeId}`
              : team_id && user_id
                ? `?team_id=${team_id}&user_id=${user_id}`
                : dynamicQRCodeId !== null
                  ? `?dynamic_qr_code=${dynamicQRCodeId}`
                  : ""
            }`
        );
      }
    } else if (purchasedPackage.id === 1) {
      limitExceededForStarter()
        .then((isLimitExceeded) => {
          if (isLimitExceeded) {
            setShowModal(true);
          } else {
            navigate(
              teamId && userId
                ? `/team/${teamId}/teamMembers/member/${userId}/function/cardfunctions`
                : `/function/cardfunctions${team_id && user_id
                  ? `?team_id=${team_id}&user_id=${user_id}`
                  : ""
                }`
            );
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    } else {
      const res = compareLimits(functionTypes.CARD);
      if (res) {
        return showToast(
          false,
          "The requested feature is not compatible with your current plan. Upgrade your plan to continue using these features"
        );
      } else {
        navigate(
          teamId && userId
            ? `/team/${teamId}/teamMembers/member/${userId}/function/cardfunctions`
            : `/function/cardfunctions${team_id && user_id && dynamicQRCodeId !== null
              ? `?team_id=${team_id}&user_id=${user_id}&dynamic_qr_code=${dynamicQRCodeId}`
              : team_id && user_id
                ? `?team_id=${team_id}&user_id=${user_id}`
                : dynamicQRCodeId !== null
                  ? `?dynamic_qr_code=${dynamicQRCodeId}`
                  : ""
            }`
        );
      }
    }
  };

  const handleNavigationWithPrefill = (prefillData) => {
    let url = teamId && userId
      ? `/team/${teamId}/teamMembers/member/${userId}/function/cardfunctions`
      : `/function/cardfunctions${team_id && user_id && dynamicQRCodeId !== null
        ? `?team_id=${team_id}&user_id=${user_id}&dynamic_qr_code=${dynamicQRCodeId}`
        : team_id && user_id
          ? `?team_id=${team_id}&user_id=${user_id}`
          : dynamicQRCodeId !== null
            ? `?dynamic_qr_code=${dynamicQRCodeId}`
            : ""
      }`;

    navigate(url, { state: { prefill: prefillData } });
  };

  return (
    <>
      {!loading ? (
        <div className="">
          <div className="row align-items-center mb-4">
            <div className="col-6">
              <div className="heading">
                <h1 className="mb-0">
                  <Link to="/" className="function-link">
                    Functions
                  </Link>
                  {` > Cards`}
                </h1>
              </div>
            </div>
            <div className="col-6 text-end">
              {/* {activeTab === "business" && ( */}
              <div className="row mb-3">
                <div className="col-12">
                  <div className="form-check form-switch form-group d-flex align-items-center gap-2 justify-content-end mb-md-0">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="emailStatusSwitch"
                      checked={contactExchangeButton}
                      // onChange={handleStatusChange}
                      onChange={handleContactExchange}
                      style={{ marginTop: "-0.5px" }}
                    />
                    <label
                      className="form-check-label mb-0 me-3"
                      htmlFor="emailStatusSwitch"
                    >
                      Contact Exchange Form
                    </label>
                    <Link
                      to={
                        (`/function/formBuilder?type=business&prefill=card_form_builder`,
                        {
                          state: {
                            cardFormBuilderData:
                              businessCards.length > 0
                                ? transformCardFormBuilderData(
                                  businessCards[0].card_form_builder
                                )
                                : null,
                          },
                        })
                      }
                    >
                      <Button variant="outline-primary">
                        <FaEdit />
                      </Button>
                    </Link>
                  </div>
                </div>
              </div>
              {/* )} */}


              <div className="d-flex justify-content-end align-items-center gap-3">
                <Button variant="primary" onClick={() => setShowManualCardModal(true)} className="d-inline-flex align-items-center gap-2 text-decoration-none">
                  <FiEdit /> Create manually
                </Button>

                {/* <Button onClick={handleNewCardPopupOpen} className="ai-create-btn d-inline-flex align-items-center gap-2">
                  <BsStars /> Create with AI
                </Button> */}
              </div>

              {/* <AddNewCard
                teamId={teamId}
                userId={userId}
                team_id={team_id}
                user_id={user_id}
                getData={loadCard}
                // dynamicQRCode={dynamicQRCode}
                dynamicQRCodeId={dynamicQRCodeId}
              /> */}

              {activeTab === "business" && (
                // <Link
                //   to={`/function/formBuilder?type=business&prefill=card_form_builder`}
                //   state={{
                //     cardFormBuilderData:
                //       businessCards.length > 0
                //         ? businessCards[0].card_form_builder
                //         : null,

                //   }}

                // >
                //   <Button variant="primary" className="ms-3">
                //     <MdAddBox /> Add Contact Exchange Form
                //   </Button>
                // </Link>
                <>
                  {contactExchangeButton && (
                    <Link
                      to={`/function/formBuilder?type=business&prefill=card_form_builder`}
                      state={{
                        cardFormBuilderData:
                          businessCards.length > 0
                            ? transformCardFormBuilderData(
                              businessCards[0].card_form_builder
                            )
                            : null,
                      }}
                    >
                      <Button variant="primary" className="ms-3">
                        <MdAddBox /> Add Contact Exchange Form
                      </Button>
                    </Link>
                  )}
                </>
              )}
            </div>
          </div>
          {/* <Row>
               {personalCards.map((card) => {
                 return (
                   <Col xs={12} lg={3} key={card.id}>
                     <Card className="digitalCard">
                       <Card.Body>
                         <PersonalCard
                           {...card}
                           handleDelete={handleDelete}
                           cardListing={personalCards}
                           setCardListing={setPersonalCards}
                           teamId={teamId}
                           userId={userId}
                           team_id={team_id}
                           user_id={user_id}
                           loadCard={loadCard}
                           dynamicQRCodeId={dynamicQRCodeId}
                         />
                       </Card.Body>
                     </Card>
                   </Col>
                 );
               })}
             </Row> */}
          {/* <div className="mainWrapper">
               <h5 className="functions">
                 <Link to="/" className="function-link">
                   Functions
                 </Link>
                 {` > Cards`}
               </h5>
               {dynamicQRCodeId !== null ? (
                 <Link className="primary_button" to={`/qrcode`}>
                   {`< Back`}
                 </Link>
               ) : (
                 ""
               )}
             </div> */}
          {personalCards.length === 0 && businessCards.length === 0 ? (
            <EmptyListingBanner
              headLineText="card functions"
              title="Add Card"
              type="card"
              link={
                team_id && user_id && dynamicQRCodeId !== null
                  ? `?team_id=${team_id}&user_id=${user_id}&dynamic_qr_code=${dynamicQRCodeId}`
                  : teamId && userId
                    ? `/team/${teamId}/teamMembers/member/${userId}/function/cardfunctions`
                    : `/function/cardfunctions${team_id && user_id
                      ? `?team_id=${team_id}&user_id=${user_id}`
                      : dynamicQRCodeId !== null
                        ? `?dynamic_qr_code=${dynamicQRCodeId}`
                        : ""
                    }`
              }
              getData={loadCard}
              // dynamicQRCode={dynamicQRCode}
              dynamicQRCodeId={dynamicQRCodeId}
              onAiCreateClick={handleNewCardPopupOpen}
            />
          ) : (
            <>
              <div className="">
                {/* <div className="d-flex justify-content-between align-items-center">
                     <p className="totalBusinessCardsTitle">
                       Personal Card ({personalCards.length})
                     </p>
                     <div>
                       <FiChevronLeft
                         className="arrowBtn"
                         onClick={handlePersonalScrollLeft}
                       />
                       <FiChevronRight
                         className="arrowBtn"
                         onClick={handlePersonalScrollRight}
                       />
                     </div>
                   </div> */}
                <div>
                  {/* Tab headers */}
                  <ul className="nav nav-tabs mb-3" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button
                        className={`nav-link ${activeTab === "personal" ? "active" : ""
                          }`}
                        onClick={() => setActiveTab("personal")}
                        type="button"
                        role="tab"
                        aria-selected={activeTab === "personal"}
                      >
                        Personal Card ({personalCards.length})
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className={`nav-link ${activeTab === "business" ? "active" : ""
                          }`}
                        onClick={() => setActiveTab("business")}
                        type="button"
                        role="tab"
                        aria-selected={activeTab === "business"}
                      >
                        Business Card ({businessCards.length})
                      </button>
                    </li>
                  </ul>

                  {/* Tab contents */}
                  <div className="tab-content">
                    {activeTab === "personal" && (
                      <div className="tab-pane active" role="tabpanel">
                        {/* <div className="d-flex justify-content-between align-items-center mb-2">
                         <p className="totalBusinessCardsTitle">
                           Personal Card ({personalCards.length})
                         </p>
                         <div>
                           <FiChevronLeft
                             className="arrowBtn"
                             onClick={handlePersonalScrollLeft}
                           />
                           <FiChevronRight
                             className="arrowBtn"
                             onClick={handlePersonalScrollRight}
                           />
                         </div>
                       </div> */}

                        <div className="row g-3" id="personalCardWrapper">
                          {personalCards.map((card) => (
                            <div className="col-3" key={card.id}>
                              <PersonalCard
                                {...card}
                                handleDelete={handleDelete}
                                cardListing={personalCards}
                                setCardListing={setPersonalCards}
                                teamId={teamId}
                                userId={userId}
                                team_id={team_id}
                                user_id={user_id}
                                loadCard={loadCard}
                                dynamicQRCodeId={dynamicQRCodeId}
                              />
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {activeTab === "business" && (
                      <div className="tab-pane active" role="tabpanel">
                        {/* <div className="d-flex justify-content-between align-items-center mb-2">
                         <p className="totalBusinessCardsTitle">
                           Business Card ({businessCards.length})
                         </p>
                         <div>
                           <FiChevronLeft
                             className="arrowBtn"
                             onClick={handleBusinessScrollLeft}
                           />
                           <FiChevronRight
                             className="arrowBtn"
                             onClick={handleBusinessScrollRight}
                           />
                         </div>
                       </div> */}

                        <div className="row g-3" id="businessCardWrapper">
                          {businessCards.map((card) => (
                            <div className="col-3" key={card.id}>
                              <BusinessCard
                                {...card}
                                handleDelete={handleDelete}
                                cardListing={businessCards}
                                setCardListing={setBusinessCards}
                                teamId={teamId}
                                userId={userId}
                                team_id={team_id}
                                user_id={user_id}
                                loadCard={loadCard}
                                dynamicQRCodeId={dynamicQRCodeId}
                              />
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {/*  <div className="row" id="personalCardWrapper">
                     <AddNewCard
                       teamId={teamId}
                       userId={userId}
                       team_id={team_id}
                       user_id={user_id}
                       getData={loadCard}
                       dynamicQRCode={dynamicQRCode}
                       dynamicQRCodeId={dynamicQRCodeId}
                     />


                     {personalCards.map((card) => {
                       return (
                         <div className="col-3" key={card.id}>
                           <PersonalCard
                             key={card.id}
                             {...card}
                             handleDelete={handleDelete}
                             cardListing={personalCards}
                             setCardListing={setPersonalCards}
                             teamId={teamId}
                             userId={userId}
                             team_id={team_id}
                             user_id={user_id}
                             loadCard={loadCard}
                             dynamicQRCodeId={dynamicQRCodeId}
                           />
                         </div>
                       );
                     })}
                   </div>
                   <div className="d-flex justify-content-between align-items-center">
                     <p className="totalBusinessCardsTitle">
                       Business Card ({businessCards.length})
                     </p>
                     <div>
                       <FiChevronLeft
                         className="arrowBtn"
                         onClick={handleBusinessScrollLeft}
                       />
                       <FiChevronRight
                         className="arrowBtn"
                         onClick={handleBusinessScrollRight}
                       />
                     </div>
                   </div>
                   <div className="row" id="businessCardWrapper">
                     {businessCards.map((card) => {
                       return (
                         <div className="col-3" key={card.id}>
                           <BusinessCard
                             key={card.id}
                             {...card}
                             handleDelete={handleDelete}
                             cardListing={businessCards}
                             setCardListing={setBusinessCards}
                             teamId={teamId}
                             userId={userId}
                             team_id={team_id}
                             user_id={user_id}
                             loadCard={loadCard}
                             dynamicQRCodeId={dynamicQRCodeId}
                           />
                         </div>
                       );
                     })}
                   </div> */}
              </div>
            </>
          )}
        </div>
      ) : (
        <Loader />
      )}

      <style type="text/css">
        {`
       .cardsMainWrapper {
        
       }
       .cardsMainWrapper h6 {
         font-weight: 700;
         line-height: 100%;
       }

       

       .cardsWrapper {
         background: var(--secondary_color);
         padding: 40px 24px;
         margin: 18px 0px;
         border-radius: 20px;
       }


       .linkViewAll {
         padding: 6px 10px;
         background: var(--secondary_Color);
         border-radius: 10px;
         font-weight: 500;
         font-size: 12px;
         line-height: 18px;
         color: var(--primary_text_color);
         text-transform: capitalize;
       }
       .linkViewAll span {
         margin-left: 15px;
       }
       .linkViewAll:hover {
         color: var(--primary_text_color);
         opacity: 0.7;
       }


       .boxWrapper {
         display: flex;
         flex-wrap: nowrap;
         column-gap: 30px;
         margin-top: 20px;
         overflow-y: auto;
         overflow-x: scroll;
         scroll-behavior: smooth;
         scrollbar-width: none;
         padding-top: 20px;
         padding-bottom: 30px;
       }


       .boxWrapper::-webkit-scrollbar {
         display: none;
         width: 5px;
         height: 3px;
       }
       .boxWrapper::-webkit-scrollbar-track {
         border-radius: 0;
         background: var(--white);
       }
       .boxWrapper::-webkit-scrollbar-thumb {
         border-radius: 0px;
         background: var(--dark);
       }


       .totalBusinessCardsTitle {
         font-size: 14px;
         line-height: 100%;
         color: var(--primary_text_color);
       }




       .arrowBtn {
         width: 30px;
         height: 30px;
         background-color: var(--secondary_Color);
         color: var(--primary_text_color);
         border-radius: 10px;
         padding: 4px;
         margin-left: 15px;
         cursor: pointer;
       }


       .arrowBtn:hover {
         color: var(--primary_text_color);
         opacity: 0.7;
       }


       .romoveInfoMainWrapper {
         display: none;
       }


      //  .infoWrapper {
      //    background: var(--tertiary_color);
      //    border: 2px solid var(--border_color);
      //    border-radius: 20px;
      //    padding: 15px;
      //    margin-top: 70px;
      //    position: relative;
      //  }


       .infoRemoveBtn {
         position: absolute;
         top: -20px;
         right: 20px;
         cursor: pointer;
       }


      //  .contentWrapper {
      //    display: flex;
      //    align-items: flex-start;
      //    gap: 20px;
      //  }
      
      //  .contentWrapper img {
      //    width: 28px;
      //    height: 28px;
      //  }


      //  .contentWrapper h6 {
      //    font-weight: 600;
      //    line-height: 24px;
      //    color: var(--primary_text_color);
      //    padding-bottom: 10px;
      //  }


      //  .contentWrapper p {
      //    font-size: 14px;
      //    line-height: 21px;
      //    color: var(--primary_text_color);
      //    padding-bottom: 10px;
      //  }


       .arrowImgWrapper {
         display: flex;
         align-items: flex-end;
         margin-bottom: 200px;
       }


       .arrowImg {
         margin-inline: 20px;
         flex: 0 0 40%;
         max-width: 40%;
       }


       .createBtnWrapper {
         flex: 1;
       }


       .arrowImg img {
         width: 100%;
       }


       .createBtnWrapper a {
         white-space: nowrap;
         padding: 10px 20px;
         background: linear-gradient(106.6deg, var(--primary_button_color_light) 0%, var(--primary_button_color) 99.84%);
         box-shadow: 0px 6px 20px rgba(34, 160, 129, 0.4);
         border-radius: 50px;
         color: var(--primary_text_color);
         transition: 0.3s all ease;
         font-weight: 600;
         font-size: 14px;
         line-height: 21px;
       }
      
       .createBtnWrapper a:hover {
         opacity: 0.7;
       }


      `}
      </style>

      <FacebookLogin
        appId="956908413125623"
        autoLoad={false}
        fields="name,email,picture"
        callback={responseFacebook}
        render={(renderProps) => {
          triggerFbLogin.current = renderProps.onClick;
          return null;
        }}
      />
      <ConfirmationModal
        show={showModal}
        handleCloseModal={handleCloseModal}
        handleConfirmDelete={handleConfirmDelete}
        confirmTitle="card"
      />
      <Modal
        show={showNewCardModal}
        onHide={handleNewCardPopupClose}
        size="md"
        centered
        backdrop="static"
        keyboard={false}
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>Create New Digital Card by AI</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* ===== Auto Create Card Section ===== */}
          <div className="text-center create-card-wrapper mb-4">
            {/* Bot Icon */}
            <div className="mb-3">
              <img src={aiLogo} alt="Link Bot" className="ai-logo-image" />
            </div>

            {/* Title */}
            <h4 className="fw-bold mb-1">Hi, I’m Link</h4>
            <p className="text-muted mb-4">
              Connect an account to auto-create your card in seconds
            </p>

            {/* Social Icons */}
            <div className="d-flex justify-content-center gap-3 mb-5">
              <div
                className="social-circle"
                style={{ cursor: "pointer" }}
                onClick={async () => {
                  socialActionTypeRef.current = "ai";
                  checkPlanLimit(async () => {
                    try {
                      await loginWithFacebook(); // opens popup; responseFacebook will do the rest
                    } catch (e) {
                      showToast(
                        false,
                        e?.message || "Facebook login cancelled/failed"
                      );
                    }
                  });
                }}
              >
                <FaFacebookF />
              </div>
              <div
                className="social-circle"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  socialActionTypeRef.current = "ai";
                  checkPlanLimit(() => handleSocialAICreate("google"));
                }}
              >
                <FaGoogle />
              </div>
              {/* <div
                className="social-circle"
                style={{ cursor: "pointer" }}
                onClick={() => handleSocialAICreate("apple")}
              >
                <FaApple />
              </div> */}
              <div
                className="social-circle"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  checkPlanLimit(() => handleSocialAICreate("linkedin"))
                }
              >
                <FaLinkedinIn />
              </div>
            </div>

            <h6 className="text-muted mb-2">Or use your profile</h6>
            <p className="text-muted mb-3">
              We only use profile info to create your digital card
            </p>

            <div className="btn-section">
              <Button
                variant="primary"
                className="px-5 rounded-pill mt-2"
                onClick={handleProceed}
              >
                Proceed
              </Button>

              {/* <Button
                variant="link"
                onClick={handleNavigation}
              >
                Skip for now
              </Button> */}

              {/* <Button variant="primary" onClick={() => setShowManualCardModal(true)} className="d-inline-flex align-items-center gap-2 text-decoration-none">
                  <FiEdit /> Create manually
                </Button> */}

              {/* ===== Existing Add New Card Component ===== */}
              <AddNewCard
                teamId={teamId}
                userId={userId}
                team_id={team_id}
                user_id={user_id}
                getData={loadCard}
                dynamicQRCodeId={dynamicQRCodeId}
              />
            </div>
          </div>
        </Modal.Body>
        <FunctionsLimitModal
          show={showLimitModal}
          handleClose={() => setShowLimitModal(false)}
          getData={loadCard}
        />
      </Modal>

      <Modal
        show={showManualCardModal}
        onHide={() => setShowManualCardModal(false)}
        size="md"
        centered
        backdrop="static"
        keyboard={false}
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>Create card manually</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="text-center create-card-wrapper mb-4">
            <h5 className="fw-bold mb-1 mt-4">Speed Up Your Setup</h5>
            <p className="text-muted mb-4">
              Connect a social account to instantly auto-fill your name and email.
            </p>

            <div className="d-flex justify-content-center gap-3 mb-5 mt-4">
              <div
                className="social-circle"
                style={{ cursor: "pointer" }}
                onClick={async () => {
                  socialActionTypeRef.current = "manual";
                  checkPlanLimit(async () => {
                    try {
                      await loginWithFacebook();
                    } catch (e) {
                      showToast(
                        false,
                        e?.message || "Facebook login cancelled/failed"
                      );
                    }
                  });
                }}
              >
                <FaFacebookF />
              </div>
              <div
                className="social-circle"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  socialActionTypeRef.current = "manual";
                  checkPlanLimit(() => loginWithGoogle());
                }}
              >
                <FaGoogle />
              </div>
            </div>

            <h6 className="text-muted mb-2">Or build your card entirely from scratch</h6>

            <div className="btn-section mt-4 mb-2">
              <Button
                variant="primary"
                className="px-5 rounded-pill mt-2 me-2"
                onClick={handleNavigation}
              >
                Proceed
              </Button>

              <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleOcrUpload}
              />
              {/* <Button
                variant="outline-primary"
                className="px-4 rounded-pill mt-2"
                onClick={() => checkPlanLimit(() => fileInputRef.current.click())}
              >
                Upload Physical Card
              </Button> */}
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Resolution Modal for OCR */}
      <Modal
        show={showResolutionModal}
        onHide={() => setShowResolutionModal(false)}
        size="lg"
        centered
        backdrop="static"
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>Review Scanned Contact</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {ocrResultData && (
            <div>
              {ocrResultData.ai_suggestions?.corrected_data && (
                <div className="mb-4 p-3 bg-light rounded border">
                  <h6 className="fw-bold text-success mb-2">AI Suggestions Found</h6>
                  <p className="text-muted small mb-2">The AI detected potential typos and fixed them. Would you like to use the AI suggested data?</p>
                  <Form.Check
                    type="switch"
                    id="ai-suggestion-switch"
                    label={useAiSuggestion ? "Using AI corrected data" : "Using original extracted data"}
                    checked={useAiSuggestion}
                    onChange={(e) => setUseAiSuggestion(e.target.checked)}
                  />
                  <div className="mt-3 row mx-0 g-2">
                    <div className="col-6 p-2 border rounded bg-white" style={{ wordBreak: "break-word" }}>
                      <small className="fw-bold d-block mb-2">Original</small>

                      {ocrResultData.ocr_data?.first_name || ocrResultData.ocr_data?.last_name ? (
                        <div className="mb-1">
                          <small className="text-muted d-block" style={{ fontSize: "0.75rem" }}>Name</small>
                          <span>{ocrResultData.ocr_data?.first_name} {ocrResultData.ocr_data?.last_name}</span>
                        </div>
                      ) : null}

                      {ocrResultData.ocr_data?.company ? (
                        <div className="mb-1">
                          <small className="text-muted d-block" style={{ fontSize: "0.75rem" }}>Company</small>
                          <span>{ocrResultData.ocr_data?.company}</span>
                        </div>
                      ) : null}

                      {ocrResultData.ocr_data?.company_position ? (
                        <div className="mb-1">
                          <small className="text-muted d-block" style={{ fontSize: "0.75rem" }}>Position</small>
                          <span>{ocrResultData.ocr_data?.company_position}</span>
                        </div>
                      ) : null}

                      {ocrResultData.ocr_data?.email ? (
                        <div className="mb-1">
                          <small className="text-muted d-block" style={{ fontSize: "0.75rem" }}>Email</small>
                          <span>{ocrResultData.ocr_data?.email}</span>
                        </div>
                      ) : null}

                      {ocrResultData.ocr_data?.phones && ocrResultData.ocr_data?.phones.length > 0 ? (
                        <div className="mb-1">
                          <small className="text-muted d-block" style={{ fontSize: "0.75rem" }}>Phone</small>
                          <span>{Array.isArray(ocrResultData.ocr_data?.phones) ? ocrResultData.ocr_data.phones.join(", ") : ocrResultData.ocr_data?.phones}</span>
                        </div>
                      ) : null}

                      {ocrResultData.ocr_data?.website ? (
                        <div className="mb-1">
                          <small className="text-muted d-block" style={{ fontSize: "0.75rem" }}>Website</small>
                          <span>{ocrResultData.ocr_data?.website}</span>
                        </div>
                      ) : null}
                    </div>

                    <div className="col-6 p-2 border rounded bg-white" style={{ wordBreak: "break-word" }}>
                      <small className="fw-bold d-block mb-2 text-success">AI Suggested</small>

                      {ocrResultData.ai_suggestions.corrected_data?.first_name || ocrResultData.ai_suggestions.corrected_data?.last_name ? (
                        <div className="mb-1">
                          <small className="text-muted d-block" style={{ fontSize: "0.75rem" }}>Name</small>
                          <span>{ocrResultData.ai_suggestions.corrected_data?.first_name} {ocrResultData.ai_suggestions.corrected_data?.last_name}</span>
                        </div>
                      ) : null}

                      {ocrResultData.ai_suggestions.corrected_data?.company ? (
                        <div className="mb-1">
                          <small className="text-muted d-block" style={{ fontSize: "0.75rem" }}>Company</small>
                          <span>{ocrResultData.ai_suggestions.corrected_data?.company}</span>
                        </div>
                      ) : null}

                      {ocrResultData.ai_suggestions.corrected_data?.company_position ? (
                        <div className="mb-1">
                          <small className="text-muted d-block" style={{ fontSize: "0.75rem" }}>Position</small>
                          <span>{ocrResultData.ai_suggestions.corrected_data?.company_position}</span>
                        </div>
                      ) : null}

                      {ocrResultData.ai_suggestions.corrected_data?.email ? (
                        <div className="mb-1">
                          <small className="text-muted d-block" style={{ fontSize: "0.75rem" }}>Email</small>
                          <span>{ocrResultData.ai_suggestions.corrected_data?.email}</span>
                        </div>
                      ) : null}

                      {ocrResultData.ai_suggestions.corrected_data?.phones && ocrResultData.ai_suggestions.corrected_data?.phones.length > 0 ? (
                        <div className="mb-1">
                          <small className="text-muted d-block" style={{ fontSize: "0.75rem" }}>Phone</small>
                          <span>{Array.isArray(ocrResultData.ai_suggestions.corrected_data?.phones) ? ocrResultData.ai_suggestions.corrected_data.phones.join(", ") : ocrResultData.ai_suggestions.corrected_data?.phones}</span>
                        </div>
                      ) : null}

                      {ocrResultData.ai_suggestions.corrected_data?.website ? (
                        <div className="mb-1">
                          <small className="text-muted d-block" style={{ fontSize: "0.75rem" }}>Website</small>
                          <span>{ocrResultData.ai_suggestions.corrected_data?.website}</span>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              )}

              {ocrResultData.has_duplicates && ocrResultData.duplicates && (
                <div className="mb-4">
                  <h6 className="fw-bold text-danger mb-2">Duplicate Contacts Detected</h6>
                  <p className="text-muted small mb-3">We found existing contacts that might be the same person. How would you like to proceed?</p>

                  <div className="d-flex flex-column gap-2 mb-3">
                    <Form.Check
                      type="radio"
                      name="duplicate_action"
                      id="action-new"
                      label="Create as completely new contact"
                      checked={selectedDuplicateAction === "new"}
                      onChange={() => setSelectedDuplicateAction("new")}
                    />
                    <Form.Check
                      type="radio"
                      name="duplicate_action"
                      id="action-merge"
                      label="Merge with existing contact (Update)"
                      checked={selectedDuplicateAction === "merge"}
                      onChange={() => setSelectedDuplicateAction("merge")}
                    />
                    {/*   */}
                  </div>

                  {selectedDuplicateAction === "merge" && ocrResultData.duplicates.length > 0 && (
                    <div className="p-3 border rounded bg-light mb-4">
                      {/* <p className="fw-bold small mb-2 text-danger">Target Contact:</p>
                      {ocrResultData.duplicates.map((dup, idx) => {
                        const dupId = dup.existing_contact_id || dup.contact_id || dup.id || idx;
                        return (
                          <Form.Check
                            key={idx}
                            type="radio"
                            name="duplicate_selection"
                            id={`dup-${idx}`}
                            label={`${dup.first_name || "-"} ${dup.last_name || "-"} (${dup.company || "No Company"}) - Confidence: ${dup.confidence}%`}
                            checked={selectedDuplicateId === dupId}
                            onChange={() => setSelectedDuplicateId(dupId)}
                          />
                        );
                      })} */}

                      <p className="fw-bold small mb-3">Edit Merge Data:</p>

                      <div className="row">
                        <div className="col-12 col-md-6 border-end" style={{ opacity: !useAiSuggestion ? 1 : 0.6, transition: 'opacity 0.2s' }}>
                          <p className="fw-bold small text-muted text-center">Original Format</p>
                          <div className="row g-2">
                            <div className="col-12">
                              <Form.Group>
                                <Form.Label className="small mb-1">First Name</Form.Label>
                                <Form.Control size="sm" type="text" name="first_name" value={editOriginalFields.first_name} onChange={handleEditOriginalChange} />
                              </Form.Group>
                            </div>
                            <div className="col-12">
                              <Form.Group>
                                <Form.Label className="small mb-1">Last Name</Form.Label>
                                <Form.Control size="sm" type="text" name="last_name" value={editOriginalFields.last_name} onChange={handleEditOriginalChange} />
                              </Form.Group>
                            </div>
                            <div className="col-12">
                              <Form.Group>
                                <Form.Label className="small mb-1">Email</Form.Label>
                                <Form.Control size="sm" type="email" name="email" value={editOriginalFields.email} onChange={handleEditOriginalChange} />
                              </Form.Group>
                            </div>
                            <div className="col-12">
                              <Form.Group>
                                <Form.Label className="small mb-1">Company</Form.Label>
                                <Form.Control size="sm" type="text" name="company" value={editOriginalFields.company} onChange={handleEditOriginalChange} />
                              </Form.Group>
                            </div>
                            <div className="col-12">
                              <Form.Group>
                                <Form.Label className="small mb-1">Position</Form.Label>
                                <Form.Control size="sm" type="text" name="company_position" value={editOriginalFields.company_position} onChange={handleEditOriginalChange} />
                              </Form.Group>
                            </div>
                            <div className="col-12">
                              <Form.Group>
                                <Form.Label className="small mb-1">Phones</Form.Label>
                                <Form.Control size="sm" type="text" name="phones" value={editOriginalFields.phones} onChange={handleEditOriginalChange} />
                              </Form.Group>
                            </div>
                            <div className="col-12">
                              <Form.Group>
                                <Form.Label className="small mb-1">Website</Form.Label>
                                <Form.Control size="sm" type="text" name="website_url" value={editOriginalFields.website_url} onChange={handleEditOriginalChange} />
                              </Form.Group>
                            </div>
                          </div>
                        </div>

                        <div className="col-12 col-md-6" style={{ opacity: useAiSuggestion ? 1 : 0.6, transition: 'opacity 0.2s' }}>
                          <p className="fw-bold small text-success text-center">AI Suggested Format</p>
                          <div className="row g-2">
                            <div className="col-12">
                              <Form.Group>
                                <Form.Label className="small mb-1">First Name</Form.Label>
                                <Form.Control size="sm" type="text" name="first_name" value={editAiFields.first_name} onChange={handleEditAiChange} />
                              </Form.Group>
                            </div>
                            <div className="col-12">
                              <Form.Group>
                                <Form.Label className="small mb-1">Last Name</Form.Label>
                                <Form.Control size="sm" type="text" name="last_name" value={editAiFields.last_name} onChange={handleEditAiChange} />
                              </Form.Group>
                            </div>
                            <div className="col-12">
                              <Form.Group>
                                <Form.Label className="small mb-1">Email</Form.Label>
                                <Form.Control size="sm" type="email" name="email" value={editAiFields.email} onChange={handleEditAiChange} />
                              </Form.Group>
                            </div>
                            <div className="col-12">
                              <Form.Group>
                                <Form.Label className="small mb-1">Company</Form.Label>
                                <Form.Control size="sm" type="text" name="company" value={editAiFields.company} onChange={handleEditAiChange} />
                              </Form.Group>
                            </div>
                            <div className="col-12">
                              <Form.Group>
                                <Form.Label className="small mb-1">Position</Form.Label>
                                <Form.Control size="sm" type="text" name="company_position" value={editAiFields.company_position} onChange={handleEditAiChange} />
                              </Form.Group>
                            </div>
                            <div className="col-12">
                              <Form.Group>
                                <Form.Label className="small mb-1">Phones</Form.Label>
                                <Form.Control size="sm" type="text" name="phones" value={editAiFields.phones} onChange={handleEditAiChange} />
                              </Form.Group>
                            </div>
                            <div className="col-12">
                              <Form.Group>
                                <Form.Label className="small mb-1">Website</Form.Label>
                                <Form.Control size="sm" type="text" name="website_url" value={editAiFields.website_url} onChange={handleEditAiChange} />
                              </Form.Group>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {!ocrResultData.has_duplicates && (
                <div className="mb-2">
                  <p className="text-muted">No duplicates detected. Ready to save.</p>
                </div>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowResolutionModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleOcrSave} disabled={loading}>
            Save Contact
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Card;
